import {EventsService} from "app/lib/EventsService";
import {OnDestroy, OnInit} from "@angular/core";
import * as qs from 'qs';

import {BaseService} from "./base.service";
import {ActivatedRoute} from "@angular/router";
import {FilterParams} from "app/models/filter_form.model";
import {FilterFormService} from "./filter_form/filter_form.service";

import dictionary from "dict/static.json";
import {TranslateService} from "../translate/translate.service";
import {Pagination} from "../models/pagination.model";

class DoReload {
	total: boolean = true;
	chart: boolean = true;
	pagination: boolean = true;
	stats: boolean = true;
	
	reset() {
		this.total = true;
		this.chart = true;
		this.pagination = true;
		this.stats = true;
	}
	
	onlyStats() {
		this.total = false;
		this.chart = false;
		this.pagination = false;
		this.stats = true;
	}
}


export class BaseComponent implements  OnInit, OnDestroy {
	public addFilterParams = {};
	
	public isLoad:boolean = true;
	
	// UPDATE Бережнов Времено добавляю BaseComponent такие поля, поскольку они часто встречаются.
	// Временно, потому что нужно придумать нормально именование
	public statsLoader: boolean = false;
	public stats = [];
	
	public currencyList = dictionary.currencyList;
	public locations    = dictionary.locations;
	public countriesMap = dictionary.locations.reduce(
		function (countriesMap, country) {
			countriesMap[country.ccode] = country.caption;
			return countriesMap;
		},
		{}
	);
	
	public localesMap = {};
	
	public emailList = Object.keys(dictionary.emailList);
	
	public links: string[] = [];
	public totalLoader: boolean = false;
	public paginationLoader: boolean = false;
	
	public isPaginationReload: boolean = false;
	
	public dontLoad: any = {};
	public doReload: DoReload = new DoReload();
	
	public pagination: Pagination = new Pagination();
	public totalsLoader: boolean = false;
	
	constructor(
		public eventsService: EventsService,
		public service: BaseService,
		public activatedRoute: ActivatedRoute,
		public filter: FilterFormService,
		public translate: TranslateService
	) {
		const me = this;
		
		this.localesMap = Object.keys(dictionary.localesMap).reduce(function(obj, key) {
			obj[key] = dictionary.localesMap[key];
			return obj;
		}, {
			'all'    : me.__a('common.any'),
			'not_ru' : 'not_ru'
		});
	}
	
	
	ngOnInit() {
		
		// Передать addFilterParams в filterService и подписать там внутри на обновление queryParams
		this.filter.setAddFilterParams(<FilterParams>this.addFilterParams);
		
		this.activatedRoute.queryParams.subscribe(() => {
			this.filter.setReportGUID();
			
			this.eventsService.broadcast(
				'filter-apply',
				this.filter.filterParams
			);
			
			this.getData();
		});
	}
	
	
	ngOnDestroy() {
		this.eventsService.broadcast(
			'compoment-destroy'
		);
	}
	
	
	async getData() {}
	
	
	updateData(filter, type?) {}
	
	
	__a(str, ...params) {
		return this.translate.__A(str, params);
	}
	
	
	// TODO запилить сюда новый сервис роутинга, скрывающий работу с применением фильтра в урл
	onPageChange(page: number = 1) {
		
	}

	updateLinks(reportUrl) {
		const me = this;

		me.links = me.pagination.items.map(function (page, i) {
			const fp = me.filter.getCopyFilterParams({ 'page': i + 1 });

			return `${reportUrl}?${qs.stringify(me.filter.getApplyFilters(fp), {encode: false})}`;
		});
	}
}
